<template>
  <layout-default-appbar filterable
    :filters="filters">
    Home
  </layout-default-appbar>
</template>

<script>
import { HOME_QUERIES } from '@/constants/QUERY_FILTERS';

import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';

export default {
  name: 'ViewPedidoAppBar',

  components: {
    LayoutDefaultAppbar,
  },

  data() {
    return {

      filters: [
        HOME_QUERIES.createdFrom,
        HOME_QUERIES.createdBefore,
      ],
    };
  },
};
</script>
